import * as React from 'react';
import useTranslation from "../hooks/useTranslation";
import {useEffect} from "react";
import {useHistory} from "react-router";

const HomeScreen = ({language, t}) => {

    return (
        <>
            <h1 className="text-center pb-2 bg-white">Smadify</h1>
            <p className="text-primary font-weight-normal text-center p-3">
                A Smadify egy olyan alkalmazás, amivel saját reklámkampányokat hozhatsz létre és azokat bármennyiszer lejátszhatod a boltjaidban.<br/><br/>
                A Smadify segítségével lehetőséged van online stream zene szolgáltatás lejátszására a reklámok között, de akár saját zeneszámokat is betölthetsz.<br/><br/>
                A Smadify segítségével lehetőséged van saját reklámjaidat kampányokba rendezni és lejátszási periódusokat / időket hozzájuk rendelni. Így a reklámjaid csak akkor és csak ott játszódnak le, ahol és amikor Te engeded.<br/>
            </p>
            <h2 className="">Saját reklám</h2>
            <p className="text-primary font-weight-normal pb-4">
                A reklámspotjaidat MP3 és WAV formátumban tudod feltölteni. Minden spothoz címkéket rendelhetsz (amennyi csak jólesik). Ezek a címkék fognak segíteni a reklámkampányok elkészítésében .
            </p>
            <h2 className="">Saját műsorfüzet</h2>
            <p className="text-primary font-weight-normal pb-4">
                A műsorfüzetben tudod beállítani a Smadify számára releváns vállalti profilt.
            </p>
            <h2 className="">Saját irányítás</h2>
            <p className="text-primary font-weight-normal pb-4">
                A Smadify kampány beállításánál Te döntöd el. hogy az adott reklámok mely napokon, milyen sűrűséggel hangozzanak el, illetve, hogy melyik boltokban hallják őket. A könnyű és gyors beállításokat a Reklámokhoz és a Boltokhoz rendelt címkék segítik.
            </p>
            <h2 className="">Smadify kampányok</h2>
            <p className="text-primary font-weight-normal pb-4">
                A Smadify kampány olyan célirányos reklámok összessége, amiben a reklámüzenetek meghatározott gyakorisággal jutnak el boltjaid célközönségéhez.
            </p>
            <h2 className="">Teljesen rádszabva</h2>
            <p className="text-primary font-weight-normal pb-4">
                A Smadify-ban beállíthatod a saját zeneszolgáltatódat, valamint a korlátlan számú boltjaidat itt tudod paraméterezni a kampányaidhoz.
            </p>
            <h2 className="">Többet a Smadifyról</h2>
            <p className="text-primary font-weight-normal pb-4">
                Ha szeretnél többet tudni a Smadifyról, akkor <a href="http://augmentit.hu/smadify/" target="_blank" className="text-dark"><u>kattints ide!</u></a>
            </p>
        </>
    );
};

export default HomeScreen;
